module.exports = require('./helpers/bundle-url').getBundleURL('52vsC') + "logo-dark.eefe0b7f.svg";